import React from 'react'
import formConfig from "../../../formJsonData/Purchase/DepartmentMaster/DepratmentList.json"
import Forms from '../../../components/common/Form';
import searchConfigJson from "../../../formJsonData/LMS/searchFilterFields.json"

const DepartmentList = () => {
  return (
    <div>
      <Forms formConfig={formConfig} searchConfigJson={searchConfigJson.departmentmasterList}/>
    </div>
  )
}

export default DepartmentList
